export const ChannelSaveIcon: React.FC = () => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={{ cursor: 'pointer', marginLeft: '16px' }}
  >
    <path
      d='M12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12C2 6.48 6.48 2 12 2Z'
      fill='#858688'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M16.3875 7.73454C15.9092 7.4584 15.2977 7.62228 15.0215 8.10057L11.3573 14.4472L8.62166 11.7116C8.23113 11.3211 7.59797 11.3211 7.20744 11.7116C6.81692 12.1022 6.81692 12.7353 7.20744 13.1259L10.8123 16.7307C10.8303 16.7487 10.8488 16.7658 10.8677 16.7821C10.9278 16.8418 10.9965 16.8948 11.0732 16.9392C11.5515 17.2153 12.1631 17.0514 12.4393 16.5731L16.7536 9.10057C17.0297 8.62228 16.8658 8.01069 16.3875 7.73454Z'
      fill='white'
    />
  </svg>
);
